export default {"src":"/_next/static/media/buy-now.faef55ce.svg","height":24,"width":24};